import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import GalleryDetail from "../components/GalleryDetail.vue";
import VueScrollTo from "vue-scrollto";
import ProductImagePopup from "@/components/ProductImagePopup.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: Home,
    children: [
      {
        meta: {
          showModal: true,
        },
        path: ":id",
        component: GalleryDetail,
        props: true,
      },
    ],
  },
  // {
  //   path: "/gallery/:id",
  //   name: "gallery",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const router = new VueRouter({
  routes: routes,
  mode: "history",

  scrollBehavior(to, from, savedPosition) {
    // console.log(to);
    if (to.path == "/" && to.hash == "") {
      // eslint-disable-next-line
      VueScrollTo.scrollTo("#intro", 700);
      return { x: 0, y: 0 };
    }
    if (to.path == "/gallery" && to.hash == "") {
      return savedPosition;
      // eslint-disable-next-line
      VueScrollTo.scrollTo("#intro", 700);
      return { x: 0, y: 0 };
    }

    if (to.hash) {
      // eslint-disable-next-line
      VueScrollTo.scrollTo(to.hash, 700);
      if (to.hash == "") {
        // console.log("emptyhash");
        return { x: 0, y: 0 };
      }
      return { selector: to.hash };
    } else if (savedPosition) {
      // console.log('object');
      return savedPosition;
    } else {
      // console.log('object2');
      return { x: 0, y: 0 };
    }
  },
});

export default router;
